var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsDarkActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83268 1.66602H4.99935C2.49935 1.66602 1.66602 3.15768 1.66602 4.99935V5.83268V17.4993C1.66602 18.191 2.44935 18.5827 2.99935 18.166L4.42435 17.0993C4.75768 16.8493 5.22435 16.8827 5.52435 17.1827L6.90768 18.5744C7.23268 18.8994 7.76602 18.8994 8.09102 18.5744L9.49102 17.1743C9.78268 16.8827 10.2493 16.8493 10.5743 17.0993L11.9993 18.166C12.5493 18.5743 13.3327 18.1827 13.3327 17.4993V3.33268C13.3327 2.41602 14.0827 1.66602 14.9993 1.66602H5.83268ZM4.97435 11.6743C4.51602 11.6743 4.14102 11.2993 4.14102 10.841C4.14102 10.3827 4.51602 10.0077 4.97435 10.0077C5.43268 10.0077 5.80768 10.3827 5.80768 10.841C5.80768 11.2993 5.43268 11.6743 4.97435 11.6743ZM4.97435 8.34102C4.51602 8.34102 4.14102 7.96602 4.14102 7.50768C4.14102 7.04935 4.51602 6.67435 4.97435 6.67435C5.43268 6.67435 5.80768 7.04935 5.80768 7.50768C5.80768 7.96602 5.43268 8.34102 4.97435 8.34102ZM9.99935 11.466H7.49935C7.15768 11.466 6.87435 11.1827 6.87435 10.841C6.87435 10.4993 7.15768 10.216 7.49935 10.216H9.99935C10.341 10.216 10.6243 10.4993 10.6243 10.841C10.6243 11.1827 10.341 11.466 9.99935 11.466ZM9.99935 8.13268H7.49935C7.15768 8.13268 6.87435 7.84935 6.87435 7.50768C6.87435 7.16602 7.15768 6.88268 7.49935 6.88268H9.99935C10.341 6.88268 10.6243 7.16602 10.6243 7.50768C10.6243 7.84935 10.341 8.13268 9.99935 8.13268Z",
    fill: "url(#paint0_linear_7279_119185)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.009 1.66602V2.91602C15.559 2.91602 16.084 3.14102 16.4673 3.51602C16.8673 3.92435 17.084 4.44935 17.084 4.99935V7.01602C17.084 7.63268 16.809 7.91602 16.184 7.91602H14.584V3.34102C14.584 3.10768 14.7757 2.91602 15.009 2.91602V1.66602ZM15.009 1.66602C14.084 1.66602 13.334 2.41602 13.334 3.34102V9.16602H16.184C17.5007 9.16602 18.334 8.33268 18.334 7.01602V4.99935C18.334 4.08268 17.959 3.24935 17.359 2.64102C16.7507 2.04102 15.9257 1.67435 15.009 1.66602C15.0173 1.66602 15.009 1.66602 15.009 1.66602Z",
    fill: "url(#paint1_linear_7279_119185)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7279_119185",
    x1: 8.33268,
    y1: 1.66602,
    x2: 8.33268,
    y2: 18.8181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7279_119185",
    x1: 15.834,
    y1: 1.66602,
    x2: 15.834,
    y2: 9.16602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsDarkActive);
export default __webpack_public_path__ + "static/media/reports-dark-active.9422a1fbd57ea95c97d4602854c7a4c1.svg";
export { ForwardRef as ReactComponent };